<template>
  <div class="hello">
    <table>
      <tr>
        <th colspan="3"> {{ title }}</th>
      </tr>
      <tr class="leaderCell" 
      v-for="(team, index) in sortedTeams" :key="index"
            :class="{'even': index % 2 === 0, 'odd': index % 2 !== 0 }">
            <td class="index">{{ team.index }}</td>
            <td class="name">{{ team.name }}</td>
            <td class="value">{{ team[field] }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
import getTeamsMixin from '@/data/get-teams-mixin.js'
import { mapActions } from 'vuex'

export default {
  name: 'LeaderBoard',
  mixins: [getTeamsMixin],

  props: {
    title: String,
    field: String
  },
  created() {
    // Ensure data is loaded when this component is created
    this.ensureDataLoaded()
  },
  computed : {
      sortedTeams() {
          if (!this.teamData.teams || this.teamData.teams.length === 0) {
            return [];
          }
          var clone = this.teamData.teams.slice(0);

          clone = clone.sort((a, b) => { return b[this.field] - a[this.field];});

          var index = 1;
          clone.forEach(function (hero) {
            hero.index = index++;
          })
          return clone;
      }
  },
  methods: {
    ...mapActions('teamData', ['initializeYearFromStorage']),
    async ensureDataLoaded() {
      // Check if we have data, if not, initialize it
      if (!this.teamData || Object.keys(this.teamData).length === 0) {
        await this.initializeYearFromStorage()
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
table {
  border:1px solid black;
  border-spacing: 0px 0px;
}

td.name {
  text-align: left;
  padding: 0px;
}
td.value {
  text-align: right;
  width: 30px;
  padding: 0px;
}
td.index {
  text-align: left;
  width: 30px;
  passing: 0px;
}
th {
  text-align: center;
  font-weight: bold;
}
tr.even {
  background-color: lightgrey;
}
</style>
